import { RelodeApiError } from "@relode/core";
import { CandidateDetails, CandidateShareDetails } from "../../../shared/types";
import { ErrorType } from "./errorType";

export interface CandidateState {
    ui: {
        errors: {
            type: string;
            message?: string;
            apiError?: RelodeApiError;
        }[];
        error?: {
            type: ErrorType;
            message?: string;
            apiError?: RelodeApiError;
        };
        isCandidateLoading: boolean;
        selectedCandidateTab?: string;
        isFeedbackUpdating: boolean;
    };
    data: {
        currentLeadId: number;
        currentJobId: number;
        candidate: CandidateDetails;
        candidateShareInfo: CandidateShareDetails;
    };
}

export const initialCandidateState: CandidateState = {
    ui: {
        isCandidateLoading: false,
        error: undefined,
        errors: [],
        selectedCandidateTab: "profile",
        isFeedbackUpdating: false,
    },
    data: {
        currentLeadId: undefined,
        currentJobId: undefined,
        candidate: undefined,
        candidateShareInfo: undefined,
    },
};
